import { QueryClient } from '@tanstack/react-query'

/**
 * Client TanStack Query de l'app terrain (ARCHITECTURE.md **D21**).
 *
 * Query n'est pas utilisé ici comme un client HTTP : **la source de vérité est
 * IndexedDB, pas le réseau**. Les `queryFn` liront Dexie (`src/offline/`). Ce que Query
 * apporte, c'est une ergonomie unique avec le back-office — un seul modèle
 * *chargement / erreur*, les mêmes devtools — sans imposer une seconde façon de faire.
 *
 * C'est une **fabrique**, pas une instance exportée — même raison que côté back-office :
 * un client partagé entre les tests ferait fuiter le cache d'un test au suivant
 * (`docs/CONVENTIONS-TESTS.md` § 4).
 *
 * Les défauts ci-dessous découlent tous du renversement « Dexie comme source ».
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        /**
         * **Le réglage critique de l'offline-first.** Par défaut, Query met en pause toute
         * requête quand le navigateur se déclare hors ligne. Or nos lectures visent
         * IndexedDB : mises en pause, l'app afficherait un écran de chargement infini
         * précisément dans la situation qu'elle est faite pour couvrir.
         */
        networkMode: 'always',

        /**
         * Une lecture Dexie ne « périme » pas toute seule : c'est une écriture locale qui la
         * rend obsolète. La fraîcheur viendra donc d'une invalidation explicite (l'observateur
         * `liveQuery` prévu par D21), pas d'un délai.
         */
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,

        /** Relancer une lecture locale qui a échoué ne la fera pas réussir : l'erreur est réelle. */
        retry: false,
      },
      mutations: {
        // Même raison : une écriture terrain va dans l'outbox locale (D4), jamais
        // directement sur le réseau. Elle ne doit pas attendre une connexion.
        networkMode: 'always',
      },
    },
  })
}
